import { defineChain } from '../../utils/chain/defineChain.js'

export const sapphireTestnet = /*#__PURE__*/ defineChain({
  id: 23295,
  name: 'Oasis Sapphire Testnet',
  network: 'sapphire-testnet',
  nativeCurrency: { name: 'Sapphire Test Rose', symbol: 'TEST', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://testnet.sapphire.oasis.dev'],
      webSocket: ['wss://testnet.sapphire.oasis.dev/ws'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Oasis Sapphire Testnet Explorer',
      url: 'https://testnet.explorer.sapphire.oasis.dev',
      apiUrl: 'https://testnet.explorer.sapphire.oasis.dev/api',
    },
  },
  testnet: true,
})
